export enum DeviceType {
  Desktop = 'desktop',
  Mobile = 'mobile',
  iOS = 'iosphone',
  Android = 'androidphone',
}

export enum AdZone {
  ARTIKEL = 'artikel',
  DEFAULT = '_default',
  HOMEPAGE = 'homepage',
  KARTE = 'karte',
  KLIMA_UPDATE = 'klima_update',
  ORTE = 'orte',
}

export type AdPosition = {
  getName: () => string
  containsAd: () => boolean
}

export type MoltenBundle = {
  getClient: () => {
    setSiteType: (type: DeviceType) => void
    setZone: (zone: string) => void
    setKeywords: (keywords: Array<string>) => void
    setIsIndexPage: (isIndex: boolean) => void
    reloadAds: () => void
  }
  cmd: Array<() => void>
  pushArray: (adslotIds: Array<string>) => void
  finalize: () => void
  push: (adSlotId: string) => void
  Video: {
    getSXPKeysAsync: () => Promise<string>
  }
  registerAdPositionLoadedHandler: (
    callback: (position: AdPosition) => void,
  ) => void
}
